import { Navigate, useParams } from 'react-router-dom';

/** Preserve section bookmarks after moving platform tools out of CER details. */
export default function CerLegacyRedirect({ section }: { section: string }) {
	const { id, userId } = useParams<{ id: string; userId: string }>();
	const to =
		section === 'dati'
			? '/dati'
			: section === 'users'
				? `/users${userId ? `/${userId}` : ''}`
				: // `general` compreso: nome e amministratori stanno nel dettaglio (INB-374).
					`/cer/orgs/${id}/details`;
	return <Navigate to={to} replace />;
}
